import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AffiliateService {

  constructor(private http: HttpClientService, ) {
  }

  public getStatistics(id: number): Observable<any> {
    return this.http.get(`affiliate/statistics?customerId=${id}`);
  }

  public linksByCustomer(id: number): Observable<any> {
    return this.http.get(`affiliate/links-by-customer?customerId=${id}`);
  }

  public productList(id: number): Observable<any> {
    return this.http.get(`affiliate/getProductList?customerId=${id}`);
  }

  public featuredProduct(): Observable<any> {
    return this.http.get(`affiliate/featured-product`);
  }

  public getReferredUser(referralCode: string): Observable<any> {
    return this.http.get(`/affiliate/getReferedUser?referralCode=${referralCode}`);
  }
}
